import styled from 'styled-components';

import { BLACK, BG_GRAY, MOBILE_PADDING, PAGE_WIDTH, SCREEN_LOCKUP_WIDTH } from '../../styles/variables.style';
import media from '../../styles/media.style';

export const Section = styled.section`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 20px 40px;
  width: 100%;
  max-width: ${PAGE_WIDTH}px;
  min-height: 0%; // for IE
  margin: 20px auto;

  ${media.tabletL`
    padding: 20px ${MOBILE_PADDING}px;
    margin: 40px auto;
    padding: 40px 100px ${({ extended }) => (extended ? '36em' : '4em')};
  `};
`;

export const ChildSection = styled.div`
  min-height: 0%;
`;

export const HowToContainer = styled(ChildSection)`
  margin: 0 auto;
  margin-bottom: 80px;

  width: 100%;
  &:last-child {
    margin-bottom: 0;
  }
  h5 {
    color: rgb(51, 51, 51);
    font-size: 16px;
    font-weight: 600;
    position: relative;
    margin: 0 0 3em;
    text-align: center;
    text-transform: uppercase;

    &::after {
      content: '';
      position: absolute;
      bottom: -18px;
      left: 50%;
      transform: translateX(-50%);
      background-color: ${BG_GRAY};
      height: 3px;
      width: 40px;
    }
  }
  ${media.tabletL`
    h5 {
      margin: 0 0 7em;
    }
  `};
`;

export const VideoWrapper = styled.div`
  width: 100%;
  max-width: ${SCREEN_LOCKUP_WIDTH}px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: space-between;

  margin: 0 auto;
  margin-bottom: 80px;
  max-width: ${SCREEN_LOCKUP_WIDTH}px;
`;

export const TextWrapperTwoColumn = styled(TextWrapper)`
  ${media.tabletL`
    flex-direction: ${({ imageRight }) => (imageRight ? 'row-reverse' : 'row')};
  `};
`;

export const HowToImageWrapper = styled.div`
  width: 100%;
  min-height: 0%;
  img {
    width: 100%;
    vertical-align: bottom;
  }
  ${media.tabletL`
    width: ${({ TwoColumn }) => (TwoColumn ? '45%' : '100%')};
    max-width: ${({ TwoColumn }) => (TwoColumn ? '450px' : 'none')};
  `};
`;

export const Text = styled.p`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 20px 0 0 0;
  min-height: 0%;

  color: ${BLACK};

  h1,
  h2,
  h3,
  p {
    font-size: 16px;
    line-height: 1.5em;
    font-weight: 400;
    margin: 0 0 20px 0;
  }
  h2 {
    font-size: 28px;
    line-height: 38px;
    margin: 0 0 20px 0;
    text-transform: uppercase;
  }

  ${media.tabletL`
    margin: 25px 0 0 0;
  `};
`;

export const TextTwoColumn = styled(Text)`
  ${media.tabletL`
    width: 45%;
    max-width: 450px;
  `};
`;

export const Title = styled.h5`
  position: relative;
  font-size: 16px;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin: 0 0 60px;
  text-align: center;

  &::after {
    content: '';
    position: absolute;
    bottom: -18px;
    left: 50%;
    transform: translateX(-50%);
    background-color: ${BG_GRAY.COMMON_8};
    height: 3px;
    width: 40px;
  }

  ${media.tabletL`
    margin-bottom: 175px;
  `};
`;



// WEBPACK FOOTER //
// ./src/components/ProductHowTo/ProductHowTo.style.js